import useNetworkConfiguration from 'hb-react/publicoffice/utils/useNetworkConfiguration';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import App from './containers/App';

const ToastsApp = ({ env, builderDisableStyledSystemCache }) => {
  const envIsBO = env === 'bo';
  const { networkConfiguration } = useNetworkConfiguration({
    // Do not fetch colors on BO - not needed for now
    colorNeeded: !envIsBO,
    styleNeeded: false,
    // Do not fetch theming on BO - not needed for now
    themingNeeded: !envIsBO,
  });

  if (!envIsBO) {
    if (!networkConfiguration) {
      return null;
    }
  }

  const { colors, theming } = networkConfiguration || {};

  return (
    <ThemeProvider
      // This prop is needed to disable the styled-system cache in the builder
      // otherwise, the toasts on the builder mobile mode have the wrong styles (mobile instead of desktop)
      builderDisableStyledSystemCache={builderDisableStyledSystemCache}
      theme={env}
      options={{
        customNetworkColors: envIsBO ? null : colors?.colors,
        customNetworkTheming: envIsBO ? null : theming?.theming,
      }}
    >
      <App env={env} />
    </ThemeProvider>
  );
};

export default ToastsApp;
